import { Label } from '@neo/primitives/label'
import { Switch } from '@neo/primitives/switch'
import { Tooltip } from '@neo/primitives/tooltip'
import { useStore } from '@xyflow/react'
import { useTypedReactFlow } from '../../hooks/use-react-flow'
import { useFlowStore } from '../../store'
import {
  hasInvalidLeaderProfile,
  isSwitchable,
  LEADER_PROFILE_V1,
  SYSTEM_ONE_THINKING_INVALID,
  stampLeaderProfile,
} from '../../utils/system-one-thinking'

export const SystemOneThinkingSwitch = () => {
  const isEditing = useFlowStore((state) => state.isEditing)
  const leaderProfile = useFlowStore((state) => state.leaderProfile)
  const canSwitch = useStore((state) => state.nodes.some(isSwitchable))
  const isInvalid = useStore((state) => hasInvalidLeaderProfile(state.nodes))
  const { setNodes } = useTypedReactFlow()

  if (!canSwitch && !isInvalid) return null

  const switchTo = (isOn: boolean) => {
    const next = isOn ? LEADER_PROFILE_V1 : null
    useFlowStore.getState().setLeaderProfile(next)
    setNodes((nodes) => stampLeaderProfile(nodes, next))
    useFlowStore.getState().markUserChange()
  }
  const viewModeHint = isEditing ? undefined : 'Click Edit to change'

  return (
    <Tooltip content={isInvalid ? SYSTEM_ONE_THINKING_INVALID : viewModeHint}>
      <div className="ml-1 flex shrink-0 items-center gap-2 whitespace-nowrap border-l border-st2 pl-3">
        <Label htmlFor="system-one" className={isInvalid ? 'text-destructive' : 'text-primary'}>
          System One Thinking
        </Label>
        <Switch
          id="system-one"
          // An invalid saved profile reads as on, so the first click removes it.
          value={isInvalid || leaderProfile !== null}
          onChange={switchTo}
          disabled={!isEditing}
          aria-invalid={isInvalid}
          data-testid="switch-system-one-thinking"
        />
      </div>
    </Tooltip>
  )
}
